<style lang="scss" scoped>
.gift-message {
  background-color: rgba(#fff, 0.1);
}

img {
  max-width: 100%;
}
</style>

<template>
  <div class="gift-message p-2 mb-2">
    <img @load="$bus.$emit('new-message')" :src="url" alt="Geschenk" />
    <div class="text-center">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: ["message"],
  data() {
    return {
      gift: {}
    };
  },
  created() {
    this.$http
      .get("/api/v1/gift", {
        params: {
          filter: [
            {
              name: "where",
              attributes: {
                id: [Number(this.message.meta.giftId)]
              }
            }
          ]
        }
      })
      .then(({ data }) => {
        this.gift = data[0];
      });
  },
  computed: {
    url() {
      return `/api/v1/gift/${this.message.meta.giftId}`;
    },
    title() {
      return this.gift ? this.gift.title : "";
    }
  }
};
</script>
